import { useMutation } from "@tanstack/react-query";
import { getNookClient } from "../client.js";
export function useDeleteAccount() {
    return useMutation({ mutationFn: (body) => getNookClient().deleteAccount(body) });
}
//# sourceMappingURL=use-delete-account.js.map